import axios from "axios";

const BASE_API_URL = "/web/rest-fp/income-insurance/invite";

export function finalizeForm(formData) {
    return axios
        .post(`${BASE_API_URL}/submit`, formData)
        .then(result => result.data);
}

export function getInviteTypes() {
    return axios
        .get(`${BASE_API_URL}`)
        .then(result => result.data);
}